import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import _ from "lodash";
import moment from "moment-timezone";
import "./MediaVideo.scss";

import {Link} from "react-router-dom";
import history from "../../../../../../libs/history";
import DraftContentReader from "../../../../../components/editor/DraftContentReader";
import createLink from "../../../../../../libs/createLink";
import SelectThumb from "../SelectThumb/SelectThumb";

import Player from "../../../../../components/Player";
import Tags from "../Tags/Tags";
import {apiUrl} from "../../../../../../libs/api";
import {LoadingBar} from "../../../../../components/Loader";

import LikeBtn from "../../../../../components/Like/LikeBtn";
import Report from "../../../../../components/Report";
import {contentRawToText} from "../../../../../../libs/helper";
import ViewMore from "../../../../../components/ViewMore";
import {reportMedia} from "../../../../../../creators/report";
import {
    fetchVerificationMedias,
    resetVerificationMedias
} from "../../../../../../creators/tagModeration.verification.medias";


class MediaVideo extends Component {
    constructor(props) {
        super(props);
        this.setTimeOut = null;
        this.classGender = [
            '',
            'gender-1',
            'gender-2',
            'gender-3',
            'gender-3',
            'gender-3',
            'gender-6',
        ];
        this.classBorderGender = [
            '',
            'gender-border-1',
            'gender-border-2',
            'gender-border-3',
            'gender-border-3',
            'gender-border-3',
            'gender-border-6',
        ];
        this.listGender = [
            '',
            'Homme',
            'Femme',
            'Couple',
            'Couple',
            'Couple',
            'Travesti',
        ];
        this.state = {
            currentIndex : 0,
            currentMedia : {},
            temperatureId : null,
            genderId : null,
            categoriesSelected : [],
            currentSteep : 1,
        }
        this.props.resetVerificationMedias();
        this.getMedias();
        this.nextSteep = this.nextSteep.bind(this);
        this.updateCurrentMedia = this.updateCurrentMedia.bind(this);
        this.updateCategoriesSelected = this.updateCategoriesSelected.bind(this);
        this.onSubmitCurrentMedia = this.onSubmitCurrentMedia.bind(this);
        this.handleReport = this.handleReport.bind(this);

    }

    componentWillUnmount() {
        this.props.resetVerificationMedias();
        this.setState({
            currentIndex : 0,
            currentMedia : {},
            temperatureId : null,
            genderId : null,
            categoriesSelected : [],
            currentSteep : 1,
        });
        clearTimeout(this.setTimeOut);

    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.verificationMediasInitialized !== this.props.verificationMediasInitialized && this.props.verificationMediasInitialized){
            if(_.get(this.props.verificationMedias,'[0].media')){
                let currentMedia = this.props.verificationMedias[0].media;
                let categoriesSelected = currentMedia.categories.filter(item => !['temperature', 'genre','media'].includes(item.parents[0].slug)).map(item => item._id.toString());
                  let temperatureId = currentMedia.categories.filter(item => item.parents[0].slug === "temperature");
                let genderId = currentMedia.categories.filter(item => item.parents[0].slug === "genre");
                this.setState({currentMedia, categoriesSelected, currentIndex : 0, currentSteep : 1, temperatureId : _.get(temperatureId, '[0]._id'), genderId : _.get(genderId, '[0]._id')});
            }
        }
        if(this.props.verificationMediasInitialized && prevProps.verificationMedias.length !== this.props.verificationMedias.length){
            let delai = moment(this.props.verificationMediasLockedUntil).diff(moment(), 'milliseconds');
            this.updateTimeOut(delai);
        }
    }

    updateTimeOut(delay = 0){
        clearTimeout(this.setTimeOut);
        if(delay > 0){
            this.setTimeOut = window.setTimeout(()=>{
                history.push(this.props.goBackUrl);
            }, delay);
        }
    }

    getMedias(more = false){
        this.props.fetchVerificationMedias({categoryId : this.props.currentCategory?._id, limit : 5, more, kind : "video"}, more);
    }

    nextMedia(){
        let currentIndex = this.state.currentIndex + 1;
        let verificationMediasTotal = this.props.verificationMedias.length || 0;

        if(_.get(this.props.verificationMedias,`[${currentIndex}].media`)){
            if((verificationMediasTotal - 2) === currentIndex ){
                this.getMedias(true);
            }
            let currentMedia = this.props.verificationMedias[currentIndex].media;
            let categoriesSelected = currentMedia.categories.filter(item => !['temperature', 'genre','media'].includes(item.parents[0].slug)).map(item => item._id.toString());
            let temperatureId = currentMedia.categories.filter(item => item.parents[0].slug === "temperature");
            let genderId = currentMedia.categories.filter(item => item.parents[0].slug === "genre");

            this.setState({
                currentIndex,
                currentMedia,
                temperatureId : _.get(temperatureId, '[0]._id'),
                genderId : _.get(genderId, '[0]._id'),
                categoriesSelected,
                currentSteep : 1,
            });
        }
        else{
            window.setTimeout(()=>{
                this.setState({
                    currentIndex,
                    currentMedia : {},
                    temperatureId : null,
                    genderId : null,
                    categoriesSelected : [],
                    currentSteep : 1,
                });
            },50)
        }
    }

    nextSteep(){
        let currentSteep = this.state.currentSteep;
        this.setState({currentSteep : currentSteep + 1});
    }

    updateCurrentMedia(key, value){
        this.setState({currentMedia : {...this.state.currentMedia, [key] : value}});
    }

    updateCategoriesSelected(categoriesSelected){
        this.setState({categoriesSelected});
    }

    onSubmitCurrentMedia(){
        if(this.state.temperatureId && this.state.genderId){
            let currentIdModeration = _.get(this.props.verificationMedias,`[${this.state.currentIndex}]._id`);
            let data = {
                categoriesIds : [this.state.temperatureId,this.state.genderId, this.props.currentCategory.parentId, ...this.state.categoriesSelected],
                //mainThumb : this.state.currentMedia.mainThumb - 1
            }
            apiUrl.patch(`/tag-moderations/verifications/update-video/${currentIdModeration}`, data).then(response=>{

            });

            this.nextMedia();
        }
    }

    handleReport(message){
        this.props.reportMedia(this.state.currentMedia._id, {message});
    }


    render() {
        let currentMedia = {...this.state.currentMedia};

        let currentGender = _.get(currentMedia,'owner.profile.gender') || 0;
        let steepComponent = [
            <SelectThumb
                mainThumb={currentMedia.mainThumb}
                imgSrc={currentMedia.previewUrl}
                updateMedia={(index)=> this.updateCurrentMedia('mainThumb', index)}
                nextSteep={()=>this.nextSteep()}
            />,
            <div className={"content"}>

                <div className={`player ${this.classBorderGender[currentGender]}`}>
                    <div className={`gender ${this.classGender[currentGender]}`}>Profil {this.listGender[currentGender]}</div>
                    <Player media={currentMedia} playsinline={true} />
                </div>
                <Tags
                    categoriesSelected={this.state.categoriesSelected}
                    categoriesSelectedTotal={this.state.categoriesSelected.length}
                    updateCategoriesSelected={this.updateCategoriesSelected}
                    updateTemperature={(temperatureId) =>this.setState({temperatureId})}
                    updateGender={(genderId) =>this.setState({genderId})}
                    temperatureId={this.state.temperatureId}
                    genderId={this.state.genderId}
                    suggestionCategories={currentMedia.suggestionCategories}
                    onSubmitCurrentMedia={this.onSubmitCurrentMedia}
                />
            </div>
        ][this.state.currentSteep] || null;

        return (
            <div id="tag-moderations-qualification-video">
                <style>
                    {`
                     header,#footer,.alert-bar{display: none !important;}
                    `}
                </style>
                {!this.props.verificationMediasInitialized ? (
                    <LoadingBar />
                ) : null}
                {this.props.verificationMediasInitialized && !currentMedia._id ? (
                    <div className={"media"}><div className={"toback"} onClick={()=> history.push(this.props.goBackUrl)}>Retour</div><span className={"text-danger"}>Aucun Media</span></div>
                ) : null}
                {this.props.verificationMediasInitialized && currentMedia._id ? (
                    <div className={"media"}>
                        <div className={"reactivity"}>
                            <div className={"toback"} onClick={()=> history.push(this.props.goBackUrl)}>Retour</div>
                            <div className={"thumbnail-likes"}>
                                <LikeBtn parentId={currentMedia._id}
                                         isLiked={currentMedia.isLiked}
                                         likeType={"medias"} />
                                <Report _id={currentMedia._id}
                                        kind={"medias"}
                                        type={"button"}
                                        handleReport={this.handleReport}
                                        title={currentMedia.title}/>
                            </div>
                            {/*<div className={"thumbnail-comments"}>{currentMedia.count.comment} reactions <Icon type={"comments-o"} /> </div>*/}
                        </div>
                        {/*<div className={"nav-breadcrumbs"}>
                            {this.props.currentCategory?.title ? this.props.currentCategory.title : ""}
                        </div>*/}
                        <div className={"media-header"}>
                            <div className={"title"}>
                                <Link className={"username"} to={createLink("userProfile", currentMedia.owner)} >{currentMedia.owner.username}</Link>
                                <span className={"separator"}>></span>
                                {currentMedia?.album?._id ? <Link className={"album-title"} to={createLink("userAlbum", {...currentMedia.owner, album : {_id : currentMedia.album._id, slug : currentMedia.album.slug}})} >{currentMedia.album.title}</Link> : <div>album introuvable</div>}
                                <span className={"separator separator-mobile"}>></span>
                            </div>
                            <div className={"title"}>
                                <Link className={"media-title"} to={createLink("mediaviewerVideo", {...currentMedia.owner, media : {_id : currentMedia._id, slug : currentMedia.slug}})}>{currentMedia.title}</Link>
                            </div>
                        </div>

                        {_.get(currentMedia,"contentRaw") && contentRawToText(currentMedia.contentRaw).length !== 0 ? <div className={"description"}><ViewMore limit={50}><DraftContentReader contentRaw={currentMedia.contentRaw} /></ViewMore></div> : null}
                        {steepComponent}
                    </div>
                ) : null}

            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        verificationMedias: state.verificationMedias.data,
        verificationMediasTotal : state.verificationMedias.total,
        verificationMediasInitialized : state.verificationMedias.initialized,
        verificationMediasLoading : state.verificationMedias.loading,
        verificationMediasLockedUntil : state.verificationMedias.lockedUntil || null,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchVerificationMedias,
    resetVerificationMedias,
    reportMedia
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MediaVideo);